import React, { useState } from "react";
import { userRolesConstants } from "../../constants/constants";

const KEY = "DevPermissionOverride";

/**
 * Dev-only floating button to fake the logged-in user's permissions
 * (role type + isBimifyAdmin) without re-login. Writes an override to
 * localStorage that tokenParams() merges into the decoded JWT.
 * FE gating only — the API still enforces real permissions.
 */
const DevSettings = () => {
	const [open, setOpen] = useState(false);
	const [override, setOverride] = useState(
		() => JSON.parse(localStorage.getItem(KEY) || "null") || {}
	);
	const active = !!localStorage.getItem(KEY);

	const apply = () => {
		const clean = Object.fromEntries(
			Object.entries(override).filter(([, v]) => v != null && v !== "")
		);
		if (Object.keys(clean).length) {
			localStorage.setItem(KEY, JSON.stringify(clean));
		} else {
			localStorage.removeItem(KEY);
		}
		// ponytail: reload beats chasing every component that read the token at render
		window.location.reload();
	};

	const reset = () => {
		localStorage.removeItem(KEY);
		window.location.reload();
	};

	const boxStyle = {
		position: "fixed",
		bottom: 16,
		left: 96,
		zIndex: 9999,
		fontSize: 13,
	};

	return (
		<div style={boxStyle} data-testid="dev-settings">
			{open && (
				<div
					style={{
						background: "#fff",
						border: "1px solid #ccc",
						borderRadius: 8,
						boxShadow: "0 2px 12px rgba(0,0,0,0.2)",
						padding: 12,
						marginBottom: 8,
						width: 220,
					}}
				>
					<div style={{ fontWeight: 600, marginBottom: 8 }}>
						Fake permissions
					</div>

					<label style={{ display: "block", marginBottom: 8 }}>
						Role
						<select
							style={{ width: "100%", marginTop: 4 }}
							value={override.roleType || ""}
							onChange={(e) =>
								setOverride({ ...override, roleType: e.target.value })
							}
							data-testid="dev-role-select"
						>
							<option value="">(real role)</option>
							{Object.values(userRolesConstants).map((role) => (
								<option key={role} value={role}>
									{role}
								</option>
							))}
						</select>
					</label>

					<label style={{ display: "block", marginBottom: 12 }}>
						isBimifyAdmin
						<select
							style={{ width: "100%", marginTop: 4 }}
							value={
								override.isBimifyAdmin == null
									? ""
									: String(override.isBimifyAdmin)
							}
							onChange={(e) =>
								setOverride({
									...override,
									isBimifyAdmin:
										e.target.value === "" ? null : e.target.value === "true",
								})
							}
							data-testid="dev-bimify-admin-select"
						>
							<option value="">(real value)</option>
							<option value="true">true</option>
							<option value="false">false</option>
						</select>
					</label>

					<div style={{ display: "flex", gap: 8 }}>
						<button
							type="button"
							className="btn btn--primary btn--small"
							onClick={apply}
						>
							Apply
						</button>
						<button
							type="button"
							className="btn btn--secondary btn--small"
							onClick={reset}
						>
							Reset
						</button>
					</div>
				</div>
			)}

			<button
				type="button"
				title="Dev settings"
				onClick={() => setOpen(!open)}
				style={{
					background: active ? "#e8590c" : "#343a40",
					color: "#fff",
					border: "none",
					borderRadius: "50%",
					width: 44,
					height: 44,
					cursor: "pointer",
					fontWeight: 700,
					boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
				}}
			>
				DEV
			</button>
		</div>
	);
};

export default DevSettings;
